export default __webpack_public_path__ + "img/padlock.43045b51.svg";